import type { ComponentProps } from "react";

export function LockSquareIcon({ ...props }: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			height={24}
			width={24}
			data-icon
			{...props}
		>
			<path
				data-icon-fill
				fill="#f5f4f4"
				d="M18.857142857142858 9.428571428571429H5.142857142857142a1.7142857142857142 1.7142857142857142 0 0 0 -1.7142857142857142 1.7142857142857142v10.285714285714285a1.7142857142857142 1.7142857142857142 0 0 0 1.7142857142857142 1.7142857142857142h13.714285714285714a1.7142857142857142 1.7142857142857142 0 0 0 1.7142857142857142 -1.7142857142857142v-10.285714285714285a1.7142857142857142 1.7142857142857142 0 0 0 -1.7142857142857142 -1.7142857142857142Z"
				strokeWidth={1}
			/>
			<path
				data-icon-stroke
				stroke="#71717b"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M18.857142857142858 9.428571428571429H5.142857142857142a1.7142857142857142 1.7142857142857142 0 0 0 -1.7142857142857142 1.7142857142857142v10.285714285714285a1.7142857142857142 1.7142857142857142 0 0 0 1.7142857142857142 1.7142857142857142h13.714285714285714a1.7142857142857142 1.7142857142857142 0 0 0 1.7142857142857142 -1.7142857142857142v-10.285714285714285a1.7142857142857142 1.7142857142857142 0 0 0 -1.7142857142857142 -1.7142857142857142Z"
				strokeWidth={1}
			/>
			<path
				data-icon-stroke
				stroke="#71717b"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M18 9.428571428571429V6.857142857142857a6 6 0 1 0 -12 0v2.571428571428571"
				strokeWidth={1}
			/>
			<path
				data-icon-stroke
				stroke="#71717b"
				fill="#71717b"
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 17.142857142857142a0.8571428571428571 0.8571428571428571 0 1 0 0 -1.7142857142857142 0.8571428571428571 0.8571428571428571 0 0 0 0 1.7142857142857142Z"
				strokeWidth={1}
			/>
		</svg>
	);
}
